/**
 * Empty marker directive for notification icons
 */
import {
  Directive
} from '@angular/core';

@Directive({
  selector: '[tdWbEmptyIcon]'
})
export class EmptyIconDirective {

}
